// extracted by mini-css-extract-plugin
export default {"header":"Alert_header__Y6flZ","danger":"Alert_danger__BXAEH","icon":"Alert_icon__2i48m","info":"Alert_info__y6CXt","success":"Alert_success__rw+8T","warning":"Alert_warning__r8Rjy"};